import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";
import { useCheckAffiliatedQueryObserver, useRatePlanQueryObserver } from "../../../../../api/services";
import { FormAutocomplete } from "../../../../../components/fields";
import { stepState } from "../../../recoil";
import { IFormValues, InsertBookingStep } from "../../../types";
import {useFormContext, useWatch} from "react-hook-form";

const FormDiscountOverprice = () => {

    const { t } = useTranslation('booking');

    const step = useRecoilValue(stepState);

    const formContext = useFormContext<IFormValues>();
    const tenant = useWatch({ control: formContext.control, name: "basicDetails.tenants" });
    const dealer = useWatch({ control: formContext.control, name: "basicDetails.dealers" });

    const ratePlanQuery = useRatePlanQueryObserver({tenant: tenant as string, dealer: dealer as string});
    const checkAffiliatedQuery = useCheckAffiliatedQueryObserver({tenant: tenant as string, dealer: dealer as string});

    return (
        <FormAutocomplete<IFormValues>
            name="extraServices.discountOverprice"
            label={t('label.discountOverprice')}
            options={ratePlanQuery.data?.discountOverprice ?? []}
            getOptionLabel={(option) => `${option} %`}
            blurOnSelect
            disabled={step === InsertBookingStep.CUSTOMER_DETAILS || (checkAffiliatedQuery.data && !!checkAffiliatedQuery.data.valid)}
        />
    );
};

export default FormDiscountOverprice;
